<template>
  <InventorySearch :show-add="false" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import InventorySearch from '@/components/elements/InventorySearch.vue'

export default defineComponent({
  name: 'Inventory',
  components: {
    InventorySearch
  }
})
</script>
